import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  variant = 'primary',
  fullWidth = false
}: CTAButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center gap-2 font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl active:translate-y-0 active:shadow-md no-underline';
  const variants = {
    primary: 'bg-orange-500 hover:bg-orange-600 text-white',
    secondary: 'bg-indigo-50 hover:bg-indigo-100 text-indigo-900 border-2 border-indigo-100'
  };
  const widthStyle = fullWidth ? 'w-full' : 'w-full sm:w-auto';
  const combinedClass = `${baseStyles} ${variants[variant]} ${widthStyle} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={combinedClass} data-id="element-7">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={combinedClass} data-id="element-8">
      {children}
    </button>;
}